import script from "./QuotationList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuotationList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__